import { type FC, type MouseEventHandler } from 'react';
import { ChevronLeft } from '@bridebook/aura/src/icons';

interface IProps {
  onClick: MouseEventHandler<HTMLDivElement>;
  label: string;
}

export const BackButton: FC<IProps> = ({ onClick, label }) => (
  <div className="bce" onClick={onClick}>
    <div>
      <div>
        <ChevronLeft />
      </div>
      {label}
    </div>
  </div>
);
